import type { UIState } from './index';

type State = { ui: UIState };

export const selectParentalControlsVisible = (state: State) => {
  const { parentalControlsManagerVisible } = state.ui;

  return parentalControlsManagerVisible;
};

export const selectFavouritesPopupVisible = (state: State) => {
  const { favouritesPopupVisible } = state.ui;

  return favouritesPopupVisible;
};

export const selectServerTime = (state: State) => {
  return state.ui.serverTime;
};

export const selectCurrentlyPlayingAssetId = (state: State) => {
  return state.ui.currentlyPlayingAsset?.id;
};

export const selectCurrentlyPlayingAsset = (state: State) => {
  return state.ui.currentlyPlayingAsset;
};

export const selectIsHeaderSticky = (state: State) => {
  return state.ui.isHeaderSticky;
};
